module.exports = __webpack_public_path__ + "img/tooltip.655f5a05.svg";